export default __webpack_public_path__ + "static/media/AllAboutThatArt.e2f0485d.png";